import { useMutation } from '@tanstack/react-query'

import { createPurchaseApplication } from '@src/api'
import { DefaultApiCreatePurchaseApplicationRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useCreatePurchaseApplication = () => {
  const { axiosInstance } = useAxios()
  return useMutation({
    mutationFn: ({
      organizationId,
      createPurchaseApplicationRequest,
      visaTransactionReferenceId,
    }: DefaultApiCreatePurchaseApplicationRequest) =>
      createPurchaseApplication(axiosInstance, {
        organizationId,
        createPurchaseApplicationRequest,
        visaTransactionReferenceId,
      }),
  })
}
